import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Home from "../components/Home";
import About from "../components/About";
import Career from "../components/Career";
import PartnerWithUs from "../components/PartnerWithUs";
import Contact from "../components/Contact";
import ComingSoon from "../components/ComingSoon";
import Projects from "../components/Projects";

const MainRoutes = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/partnerwithus" element={<PartnerWithUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/*" element={<ComingSoon />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default MainRoutes;
